// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Xnpt","footer":"Form_footer__3RnTy"};